import { useRef, useState } from "react";
import "./contact.scss";
import { CONTACT_EMAIL } from "../../config";

export default function Contact() {
  const form = useRef();
  const [status, setStatus] = useState("idle"); // idle | sending | done | needsActivation | error

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    fetch(`https://formsubmit.co/ajax/${CONTACT_EMAIL}`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form.current),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Request failed");
        return res.json();
      })
      .then((data) => {
        if (data.success === "false" || data.success === false) {
          setStatus("needsActivation");
          return;
        }
        setStatus("done");
        form.current.reset();
      })
      .catch(() => setStatus("error"));
  };

  return (
    <div className="contact" id="contact">
      <div className="left">
        <img src="assets/shake.svg" alt="Handshake illustration" />
      </div>
      <div className="right">
        <h2>Contact me</h2>
        <form ref={form} onSubmit={handleSubmit}>
          <input type="hidden" name="_subject" value="New message from portfolio site" />
          <input type="hidden" name="_template" value="table" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="email" name="email" placeholder="Email" required />
          <textarea name="message" placeholder="Message" required></textarea>
          <button type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Sending..." : "Send"}
          </button>
          {status === "done" && (
            <span className="success">Thanks, I'll reply ASAP :)</span>
          )}
          {status === "needsActivation" && (
            <span className="success">
              Almost there — check {CONTACT_EMAIL} for a one-time "Activate
              Form" email and click it. After that, every message sent here
              will reach your inbox automatically.
            </span>
          )}
          {status === "error" && (
            <span className="error">
              Something went wrong — please email me directly at {CONTACT_EMAIL}.
            </span>
          )}
        </form>
      </div>
    </div>
  );
}
